module.exports = __webpack_public_path__ + "static/arcade-frame.6a371756.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Speakers/ArcadeFrame/arcade-frame.png
// module id = 712
// module chunks = 213534597649335